import GUI from 'lil-gui'

export default class Debug {
    constructor(){
        this.active = window.location.hash === '#debug' // test si #debug est dans l'url
        if(this.active){
            this.ui = new GUI()
        }
    }
}